/* src/app/private/components/dialing-group/create-dialing-group/create-dialing-group.component.scss */
label {
  margin-bottom: 5px;
  font-weight: 500;
  font-size: 12px;
}
.errors {
  font-size: 12px;
  color: red;
}
/*# sourceMappingURL=create-dialing-group.component.css.map */
